export default {
  bannerBottomData: [
    {
      firstLineText: '19年+',
      secondLineText: '服务经验',
    },
    {
      firstLineText: '502万+',
      secondLineText: '企业服务',
    },
    {
      firstLineText: '2.7亿+',
      secondLineText: '个人用户',
    },
    {
      firstLineText: '121亿+',
      secondLineText: '总签署量',
    },
    {
      firstLineText: '24x365小时',
      secondLineText: '管家式服务',
    },
  ],

  // e签宝SaaS产品套餐
  packageTitleData: [
    {
      key: 1,
      title: '即买即用',
      desc: '1小时上线，在线极速签署电子合同',
    },
    {
      key: 2,
      title: '全终端支持',
      desc: 'web、App、短信、钉钉、小程序等',
    },
    {
      key: 3,
      title: '签审管一体',
      desc: '实现电子印章、电子/纸质合同签批存管统一管理',
    },
  ],

  // 具体套餐
  systemList: [
    {
      key: 1,
      imgSrc: require('../../assets/images/sem-pro/editions/basic.png'),
      title: '基础版',
      buttonText: '免费试用',
      descList: [
        '适用于小微企业',
        '提供覆盖多端（PC、APP、客户端、小程序）的电子签名能力，满足企业基础签署的需求，简单易上手',
        '费用：版本费+使用合同份数计费',
      ],
      descListH5: [
        '小微企业',
        '提供覆盖多端（PC、APP、客户端、小程序）的电子签名能力，满足企业基础签署的需求，简单易上手',
        '费用：版本费+使用合同份数计费',
      ],
      kindList: [
        {
          key: 1,
          icon: require('../../assets/images/sem-pro/editions_service/identity_authentication.png'),
          text: '身份认证',
        },
        {
          key: 2,
          icon: require('../../assets/images/sem-pro/editions_service/foundation_signature.png'),
          text: '基础签署',
        },
        {
          key: 3,
          icon: require('../../assets/images/sem-pro/editions_service/signature_electronics.png'),
          text: '电子签章',
        },
        {
          key: 4,
          icon: require('../../assets/images/sem-pro/editions_service/existing_evidence.png'),
          text: '存证服务',
        },
      ],
    },
    {
      key: 2,
      imgSrc: require('../../assets/images/sem-pro/editions/professional.png'),
      title: '专业版',
      buttonText: '在线咨询',
      descList: [
        '适用于成长型企业',
        '更灵活的合同签管产品，支持合同审批流、批量签署、API接口开放、合同管理等进阶功能，签署更高效，系统对接更简单',
        '费用：版本费+使用合同份数计费',
      ],
      descListH5: [
        '成长型企业',
        '更灵活的合同签管产品，支持合同审批流、批量签署、API接口开放、合同管理等进阶功能，签署更高效，系统对接更简单',
        '费用：版本费+使用合同份数计费',
      ],
      kindList: [
        {
          key: 1,
          icon: require('../../assets/images/sem-pro/editions_service/batch_signing.png'),
          text: '批量签',
        },
        {
          key: 2,
          icon: require('../../assets/images/sem-pro/editions_service/approve_sign.png'),
          text: '审批流',
        },
        {
          key: 3,
          icon: require('../../assets/images/sem-pro/editions_service/api_interface_open.png'),
          text: 'API接口开放',
        },
        {
          key: 4,
          icon: require('../../assets/images/sem-pro/editions_service/scanning_signature.png'),
          text: '扫码签署',
        },
      ],
    },
    {
      key: 3,
      imgSrc: require('../../assets/images/sem-pro/editions/premium.png'),
      title: '高级版',
      buttonText: '在线咨询',
      descList: [
        '适用于中大型/集团型企业',
        '多场景多组织解决方案支持，提供智能化合同管理服务，适配各类大型企业的内部业务系统与流程，提供集团型电子签章建设最佳实践',
        '费用：版本费+使用合同份数计费',
      ],
      descListH5: [
        '中大型/集团型企业',
        '多场景多组织解决方案支持，提供智能化合同管理服务，适配各类大型企业的内部业务系统与流程，提供集团型电子签章建设最佳实践',
        '费用：版本费+使用合同份数计费',
      ],
      kindList: [
        {
          key: 1,
          icon: require('../../assets/images/sem-pro/editions_service/multi-organization_space_management.png'),
          text: '多组织多空间管理',
        },
        {
          key: 2,
          icon: require('../../assets/images/sem-pro/editions_service/ocr_paper_contract.png'),
          text: 'OCR纸质合同',
        },
        {
          key: 3,
          icon: require('../../assets/images/sem-pro/editions_service/sso_single_sign.png'),
          text: 'SSO单点登录',
        },
        {
          key: 4,
          icon: require('../../assets/images/sem-pro/editions_service/smart_contract_management.png'),
          text: '智能合同管理',
        },
      ],
    },
  ],

  // 高级版功能亮点
  preHighLightList: [
    {
      title: '多组织管理',
      desc: '对于多组织型企业，实现多组织的机构、人员、权限统一管理，实现跨组织管理的诉求，并通过批量操作提升管理便捷性。',
      img: require('@/assets/images/sem-pro/pre_high_light/pre_high_img1.png'),
    },
    {
      title: '多业务空间隔离',
      desc: '多条业务线能够进行独立管理业务资源数据，以保证业务数据的相对保密性，数据隔离更加便捷高效',
      img: require('@/assets/images/sem-pro/pre_high_light/pre_high_img2.png'),
    },
    {
      title: 'SSO单点登录',
      desc: '通过SSO，多业务系统无需重复登录，用户体验提升的同时，统一了账户管理和权限控制，有效帮助企业控制用印风险，减少管理成本',
      img: require('@/assets/images/sem-pro/pre_high_light/pre_high_img3.png'),
    },
    {
      title: '信息采集预录入',
      desc: '通过可视化自定义表单，联动文件模板，无缝衔接了信息采集与签署发起两个环节，体验及效率全面优化，高效完成业务闭环',
      img: require('@/assets/images/sem-pro/pre_high_light/pre_high_img4.png'),
    },
    {
      title: 'OCR纸质合同',
      desc: '通过OCR识别文本内容，基于大语言模型将合同数据结构化，最终实现线上线下合同统一管理分析',
      img: require('@/assets/images/sem-pro/pre_high_light/pre_high_img5.png'),
    },
    {
      title: 'AI合同大模型',
      desc: '模型具备强大的语言理解能力，可以深入理解文本信息之间的逻辑关系，从非结构化的文本信息中抽取所需的结构化信息',
      img: require('@/assets/images/sem-pro/pre_high_light/pre_high_img6.png'),
    },
  ],
  preHighLightListH5: [
    {
      title: '多组织管理',
      img: require('@/assets/images/sem-pro/H5/pre_highLight/pre_img1.png'),
    },
    {
      title: '多业务空间隔离',
      img: require('@/assets/images/sem-pro/H5/pre_highLight/pre_img2.png'),
    },
    {
      title: 'SSO单点登录',
      img: require('@/assets/images/sem-pro/H5/pre_highLight/pre_img3.png'),
    },
    {
      title: '信息采集预录入',
      img: require('@/assets/images/sem-pro/H5/pre_highLight/pre_img4.png'),
    },
    {
      title: 'OCR纸质合同',
      img: require('@/assets/images/sem-pro/H5/pre_highLight/pre_img5.png'),
    },
    {
      title: 'AI合同大模型',
      img: require('@/assets/images/sem-pro/H5/pre_highLight/pre_img6.png'),
    },
  ],

  // 行业实践解决方案
  solutions: {
    title: '行业实践解决方案',
    list: [
      {
        videoUrl: require('../../assets/video/human-resource.mp4'),
        imgUrl: require('../../assets/images/solution1.png'),
        link: '免费试用>',
        text: '人力资源',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/logistics.mp4'),
        imgUrl: require('../../assets/images/solution2.png'),
        link: '免费试用>',
        text: '物流',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/bank.mp4'),
        imgUrl: require('../../assets/images/solution3.png'),
        link: '免费试用>',
        text: '银行',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/car-leasing.mp4'),
        imgUrl: require('../../assets/images/solution4.png'),
        link: '免费试用>',
        text: '汽车',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/medical.mp4'),

        // imgUrl: require('../../assets/images/solution5.png'),
        imgUrl: require('../../assets/images/solution8.png'),
        link: '免费试用>',
        text: '医疗',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/construction.mp4'),

        // imgUrl: require('../../assets/images/solution6.png'),
        imgUrl: require('../../assets/images/solution7.png'),
        link: '免费试用>',
        text: '房地产',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/e-commerce.mp4'),

        // imgUrl: require('../../assets/images/solution7.png'),
        imgUrl: require('../../assets/images/solution6.png'),
        link: '免费试用>',
        text: 'B2B电商',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/online-education.mp4'),

        // imgUrl: require('../../assets/images/solution8.png'),
        imgUrl: require('../../assets/images/solution5.png'),
        link: '免费试用>',
        text: '在线教育',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
    ],
  },

  // 安全可靠的电子合同服务
  safeReliableData: [
    {
      img: require('@/assets/images/sem-saas/serve-one.png'),
      title: '签管一体',
      desc: '实现电子签章、合同管理、存证与审签统一管理，助力企业半程无纸化向全程电子化过渡，使得合同签署流程更加顺畅、便捷。',
    },
    {
      img: require('@/assets/images/sem-saas/serve-two.png'),
      title: '安全可靠',
      desc: '超级计算集群云服务器数量近万台，日均签署量2000万次，平均签署耗时199ms。',
    },
    {
      img: require('@/assets/images/sem-saas/serve-three.png'),
      title: '法律支持',
      desc: '可申请出具多种类型证据报告，包括《e签宝数据存证证明》、《公证书》、《司法鉴定报告》等。',
    },
    {
      img: require('@/assets/images/sem-saas/serve-four.png'),
      title: '陪跑服务',
      desc: '全流程陪跑服务，以客户为中心，向每个企业用户配备专属顾问，为您提供及时响应、高效专业、全面细致的服务。',
    },
  ],

  // saas-ai
  saasAiData: [
    {
      key: 1,
      desc: '·【审批引擎】-内置多级审批引擎，拖曳式灵活配置',
    },
    {
      key: 2,
      desc: '·【合同比对】-AI智能比对能力，0.5秒在线比对OA审批终稿和用印文件',
    },
    {
      key: 3,
      desc: '·【智能台账】-企业合同智能化分类归档，智能获取业务数据自动形成业务台账',
    },
    {
      key: 4,
      desc: '·【信息采集】-合同签署前可灵活采集签署人信息，如身份证、学位证、家庭住址等',
    },
  ],
  orgList: {
    title: '客户案例',
    orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游'],
    imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly'].map((item) => {
      return require(`@/assets/images/${item}.png`)
    }),
  },

  // 友情链接
  friendLink: [
    {
      url: 'http://fawuren.com/',
      title: '亚太法务联盟',
    },
    {
      url: 'https://www.alibabagroup.com/cn/global/home',
      title: '阿里巴巴',
    },
    {
      url: 'https://www.antgroup.com/',
      title: '蚂蚁金服',
    },
    {
      url: 'https://www.dingtalk.com/',
      title: '钉钉',
    },
    {
      url: 'https://www.aliyun.com/',
      title: '阿里云',
    },
    {
      url: 'https://www.ruc.edu.cn/',
      title: '中国人民大学',
    },
    {
      url: 'https://www.buaa.edu.cn/',
      title: '北京航空航天大学',
    },
    {
      url: 'https://www.yonyoucloud.com/',
      title: '用友云',
    },
    {
      url: 'https://www.huawei.com/cn/?ic_medium=direct&ic_source=surlent',
      title: '华为',
    },
  ],
  agreementLink: [
    {
      url: 'https://www.esign.cn/gw/fwxy?current=1',
      title: 'e签宝服务协议',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=2',
      title: '隐私政策',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=3',
      title: 'e签宝服务等级协议',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=3',
      title: '数字证书服务协议',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=3',
      title: '认证服务协议',
    },
    {
      url: 'https://www.esign.cn/gw/fwxy?current=4',
      title: '历史版本协议',
    },
  ],
}
